// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"f208e5a5","515":"467b8a36"}[chunkId] + ".js";
};